import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";
const Home = () => import("@/views/Home.vue");
const Login = () => import("@/views/Login.vue");
const ContactLens = () => import("@/views/ContactLens.vue");
const Spectacle = () => import("@/views/Spectacle.vue");

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        name: "Login",
        path: "/login",
        component: Login
    },
    {
        name: "ContactLens",
        path: "/contactlens",
        component: ContactLens
    },
    {
        name: "Spectacle",
        path: "/spectacle",
        component: Spectacle
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
